
import React from 'react';
import ReactDOM from 'react-dom';

import GreenestSection from './GreenestSection';
import { loadData, renderSection } from './utils';
import core from '~/core/scripts';

import '../styles/index.styl';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

const colors = [
  '#63467c','#7d5f97','#987aae','#b396c1','#cdb5ce','#e5d6d4','#f9f9d1',
  '#cae2a1','#9fc97d','#77af62','#539451','#317a47','#005f43'
];

(async() => {
  const { data, dataInfo, geojson, filteredGeojson, stateGeojson } = await loadData();
  const render = (selector, props) => renderSection(selector, {
    ...props,
    filteredGeojson,
    stateGeojson,
    geojson,
    data,
    dataInfo: dataInfo.find(d => d.key === props.valueKey),
    colors: colors.slice(0),
    sectionIndex: +selector.match(/\d/)[0]
  });

  // render('#section-1', {
  //   valueKey: 'Gruene',
  //   icon: 'house',
  //   title: 'Grüne-Wähler für Startelement',
  //   text: `
  //     Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
  //     sed diam nonumy eirmod tempor invidunt ut labore et doloremagna aliquyam erat.
  //     At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,
  //     no sea takimata sanctus est Lorem ipsum dolor sit amet.
  //   `,
  //   description: 'Wähler',
  //   tooltipAbsLabel: 'Abs'
  // });

  render('#section-1', {
    valueKey: 'muell_pk',
    icon: 'trash2',
    inverted: true,
    title: 'Haushaltsmüll',
    text: `
      Die Deutschen gelten als Weltmeister bei der Mülltrennung. Immerhin werden mehr als die Hälfte aller Abfälle getrennt von Haus- und Sperrmüll gesammelt. 
      Doch die beste Option für die Umwelt bleibt die Müllvermeidung. Und Deutschlands Haushalte werfen insgesamt viel zu viel weg. 
      Beim Verpackungsmüll sind wir sogar Europameister. Innerhalb Deutschlands fällt am wenigsten Müll im Osten an - ausgerechnet in Kreisen, wo die Grünen besonders schwach sind. 
      Dennoch gilt: Wo überdurchschnittlich grün gewählt wird, fällt insgesamt etwas weniger Müll an.
    `,
    description: 'Müll ingesamt pro Kopf und Jahr privater Haushalten',
    tooltipAbsLabel: 't Müll im Jahr',
    mapSource: "Umweltbundesamt (Abfallaufkommen 2016)"
  });

  render('#section-2', {
    valueKey: 'oeko_auto',
    icon: 'electrocar',
    title: 'Elektro-Autos',
    text: `
      Elektro-Autos soll die Zukunft gehören, doch auf Deutschlands Straßen fährt die Verbrenner-Technik der Vergangenheit (98,1 Prozent Benziner und Diesel).
      Nicht einmal ein Prozent aller zugelassenen Autos sind Vollstromer oder Hybride. Auch bei den Grünen-Wählern ist der Anteil nicht viel höher.
      Das ändert sich auch nicht so schnell: Bei Neuzulassungen ist der Anteil zwar auf 7,2 Prozent gestiegen.
      Doch von einem Elektro-Boom wie in Norwegen ist Deutschland weit entfernt. 
      Dort sind mittlerweile rund 60 Prozent aller verkauften Neuwagen sogar rein elektrisch, in Deutschland nur 1,4 Prozent.
    `,
    description: 'Anteil von Elektro- und Hybrid-Autos am Pkw-Bestand',
    tooltipAbsLabel: 'Elektro-Autos',
    mapSource: "Kraftfahrt-Bundesamt (Pkw-Bestand 1/2019)"
  });

  render('#section-3', {
    valueKey: 'oeko_anteil',
    icon: 'renewableenergy2',
    title: 'Ökostrom',
    text: `
      Die Grünen können besonders in Städten punkten: Spitzenreiter bei der Europawahl waren Freiburg (38,5 Prozent) und Flensburg (37 Prozent).
      Stadtbewohner entscheiden sich wesentlich häufiger für Ökostrom als die Menschen auf dem Land. Je urbaner, desto öko.
      Das zeigt die Auswertung aller Stromwechsler der vergangenen zwei Jahre beim Vergleichsportal Verivox.
      Und tatsächlich entscheiden sich auch Flensburger und Freiburger am häufigsten für einen Stromtarif, der ausschließlich auf erneuerbare Energien setzt. 
      Dort ist es die Mehrheit, bundesweit jeder Dritte.
    `,
    description: 'Anteil der Ökostrom-Tarife beim Stromwechsel',
    tooltipAbsLabel: false,
    mapSource: "Verivox (Stromwechsel 4/2017 - 3/2019)"
  });


  render('#section-4', {
    valueKey: 'schutzgebiete',
    icon: 'nature',
    title: 'Naturschutzgebiete',
    text: `
      Bienensterben, bedrohte Singvögel, schwindende Hochmoore: Die biologische Vielfalt nimmt ab. Natur- und Artenschutzgebiete sollen diesen Trend bremsen. 
      Und auch Großstädte können solche Rückzugsorte für bedrohte Natur bieten - wie in Bremen auf einem Viertel der Stadtfläche (24 Prozent). Im thüringischen Jena ist sogar fast die Hälfte (46 Prozent). 
      Doch insgesamt ist bei den Grünen-Wählern wohl die Sehnsucht nach unberührter Natur größer als die urbane Realität vor Ort: 
      Wo die Grünen ein besonders starkes Ergebnis haben, gibt es im Durchschnitt weniger Naturschutzgebiete.
    `,
    description: 'Anteil von Natur- und Artenschutzgebieten an der Gesamtfläche',
    tooltipAbsLabel: 'km² Naturschutzgebiet',
    mapSource: "IÖR-Monitor (Natur- und Artenschutz 2017)"
  });

  render('#section-5', {
    valueKey: 'bike',
    icon: 'bicycle',
    title: 'Fahrradnutzung',
    text: `
      Insbesondere in den Großstädten gilt neben Bus und Bahn das Fahrrad als Verkehrsmittel, um die Umwelt und verstopfte Straßen zu entlasten. 
      Und eins hat fast jeder Einwohner Deutschlands (0,9 pro Kopf). Das geht aus der Studie “Mobilität in Deutschland” (MiD 2017) hervor. 
      Danach werden Fahrräder durchschnittlich für jeden neunten (11 Prozent) aller täglichen Wege genutzt. 
      Am höchsten ist der Anteil in solchen Städten, die traditionell als fahrradfreundlich gelten - wie der Spitzenreiter Münster mit fast einem Drittel. Dort sind auch die Grünen stärkste Kraft.
      (*Werte mittels statistischer Modellschätzungen auf Grundlage der MiD-Umfrage)
    `,
    description: 'Anteil des Fahrrads an allen täglichen Wegen (berechnete Werte*)',
    tooltipAbsLabel: false,
    mapSource: "infas, DLR, IVT und infas 360 (2019): Mobilität in Deutschland (im Auftrag des BMVI)"
  });

  ReactDOM.render((
    <GreenestSection
      data={data}
      geojson={geojson}
      valueKey="greenestIndex"
      colors={['#f9f9d1','#b4d68d','#77af62','#42874b','#005f43']}
      dataInfo={dataInfo}
      stateGeojson={stateGeojson}
      mapSource=""
    />
  ), document.querySelector('#greenestmap'));
})();


// this is just for development purposes -> if we are looking at a layout-sample,
// we check if there is a corresponding js file
if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!../index.html');

  if (location.pathname.includes('.html')) {
    const fileToLoad = location.pathname.replace('.html', '.js');
    try {
      require(`../layout-samples${fileToLoad}`);
    } catch(e) {
      console.log(e);
      console.log(`[Starterkit] no file found ${fileToLoad}`);
    }
  }
}
